import React, { Component } from 'react'
import { Button, Input, InputLabel, FormControl } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from '../../styles/app';

class EditCounterDataForm extends Component {

    state = {
        _id: this.props.apartmentCounterData._id,
        counter: this.props.apartmentCounterData.counter
    };

    render() {
        const { classes } = this.props;
        return (
            <form encType="multipart/form-data" className={classes.form} onSubmit={(e) => { e.preventDefault(); this.props.onSubmitForm(e, this.state) }}>
                <FormControl fullWidth>
                    <InputLabel htmlFor="counterValue">Sayaç Endeksi</InputLabel>
                    <Input
                        id="counterValue"
                        name="counterValue"
                        type="text"
                    />
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel htmlFor="periodDescription">Dönem Notu</InputLabel>
                    <Input
                        multiline
                        rows={4}
                        id="periodDescription"
                        name="periodDescription"
                        type="text"
                    />
                </FormControl>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                >
                    Sayaç Verisini Güncelle
                </Button>
            </form >
        )
    }
}
export default withStyles(styles)(EditCounterDataForm);
